var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDrama(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 322.945,
    y1: 184.353,
    y2: 184.353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.321,
    x2: -59.559,
    y1: 231.496,
    y2: -47.575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5881,
    stopColor: "#1e7ad1",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8f4ec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833ac1"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.472,
    x2: 161.472,
    xlinkHref: "#lg1",
    y1: 320.704,
    y2: 241.02
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.864,
    x2: 113.395,
    xlinkHref: "#lg1",
    y1: 115.571,
    y2: 150.102
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#662d90",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    stopColor: "#632d8c",
    stopOpacity: 0.305
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5953,
    stopColor: "#5b2d81",
    stopOpacity: 0.595
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8785,
    stopColor: "#4d2d6e",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452d63"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.766,
    x2: 126.414,
    xlinkHref: "#lg2",
    y1: 135.765,
    y2: 67.605
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.13,
    x2: 258.661,
    xlinkHref: "#lg1",
    y1: 115.571,
    y2: 150.102
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.031,
    x2: 271.679,
    xlinkHref: "#lg2",
    y1: 135.765,
    y2: 67.605
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.055,
    x2: 510,
    y1: 325.647,
    y2: 325.647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.377,
    x2: 127.497,
    y1: 372.791,
    y2: 93.72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.528,
    x2: 348.528,
    xlinkHref: "#lg3",
    y1: 421.768,
    y2: 366.013
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.919,
    x2: 300.451,
    xlinkHref: "#lg3",
    y1: 256.865,
    y2: 291.397
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    stopColor: "#ed725d",
    stopOpacity: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8514,
    stopColor: "#fa704b",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.821,
    x2: 313.469,
    xlinkHref: "#lg4",
    y1: 277.059,
    y2: 208.899
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.185,
    x2: 445.716,
    xlinkHref: "#lg3",
    y1: 256.865,
    y2: 291.397
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.086,
    x2: 458.734,
    xlinkHref: "#lg4",
    y1: 277.059,
    y2: 208.899
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m280.349 3.812c21.507-5.687 42.596 10.38 42.596 32.626v134.165c0 72.323-38.695 139.105-101.424 175.093l-14.203 8.136c-28.393 16.286-63.298 16.286-91.691 0l-14.203-8.136c-62.729-35.988-101.424-102.771-101.424-175.093v-134.165c0-22.246 21.089-38.313 42.596-32.626 33.141 8.763 74.292 13.954 118.877 13.954s85.735-5.191 118.876-13.954z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.318 353.832 14.203-8.136c62.728-35.988 101.424-102.77 101.424-175.093v-134.165c0-22.246-21.089-38.313-42.596-32.626-33.141 8.763-74.292 13.954-118.877 13.954v348.28c15.825 0 31.649-4.071 45.846-12.214z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m161.472 262.756c34.555 0 59.356 10.573 74.043 19.403 6.679 4.015 14.695-2.593 12.044-9.921-11.154-30.832-45.476-53.286-86.087-53.286s-74.933 22.454-86.087 53.286c-2.651 7.328 5.366 13.936 12.044 9.921 14.688-8.83 39.489-19.403 74.043-19.403z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m115.501 125.547c0 14.725-11.937 26.662-26.662 26.662s-26.662-11.937-26.662-26.662 11.937-26.662 26.662-26.662c14.726 0 26.662 11.937 26.662 26.662z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.766 101.697c1.798 3.589 2.812 7.639 2.812 11.926 0 14.725-11.937 26.662-26.662 26.662-4.287 0-8.338-1.014-11.927-2.812 4.377 8.737 13.412 14.735 23.85 14.735 14.725 0 26.662-11.937 26.662-26.662 0-10.437-5.998-19.472-14.735-23.849z",
    fill: "url(#SVGID_5_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m260.767 125.547c0 14.725-11.937 26.662-26.662 26.662s-26.662-11.937-26.662-26.662 11.937-26.662 26.662-26.662 26.662 11.937 26.662 26.662z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.032 101.697c1.798 3.589 2.812 7.639 2.812 11.926 0 14.725-11.937 26.662-26.662 26.662-4.287 0-8.338-1.014-11.927-2.812 4.377 8.737 13.412 14.735 23.85 14.735 14.725 0 26.662-11.937 26.662-26.662 0-10.437-5.999-19.472-14.735-23.849z",
    fill: "url(#SVGID_7_)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m467.404 145.106c21.507-5.686 42.596 10.38 42.596 32.626v134.165c0 72.323-38.695 139.105-101.424 175.093l-14.203 8.136c-28.393 16.286-63.298 16.286-91.691 0l-14.203-8.136c-62.728-35.988-101.424-102.77-101.424-175.093v-134.165c0-22.246 21.089-38.312 42.596-32.626 33.141 8.763 74.292 13.954 118.877 13.954s85.736-5.191 118.876-13.954z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.373 495.126 14.203-8.136c62.729-35.988 101.424-102.771 101.424-175.093v-134.165c0-22.246-21.089-38.313-42.596-32.626-33.141 8.763-74.292 13.954-118.877 13.954v348.28c15.825 0 31.65-4.071 45.846-12.214z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m348.528 380.864c34.555 0 59.356-10.573 74.043-19.403 6.679-4.015 14.695 2.593 12.044 9.921-11.154 30.832-45.476 53.286-86.087 53.286s-74.933-22.454-86.087-53.286c-2.651-7.328 5.366-13.936 12.044-9.921 14.687 8.831 39.488 19.403 74.043 19.403z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m302.557 266.841c0 14.725-11.937 26.661-26.662 26.661s-26.662-11.937-26.662-26.661c0-14.725 11.937-26.662 26.662-26.662s26.662 11.937 26.662 26.662z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.821 242.991c1.798 3.589 2.812 7.639 2.812 11.926 0 14.725-11.937 26.662-26.662 26.662-4.287 0-8.338-1.014-11.927-2.812 4.377 8.737 13.412 14.735 23.85 14.735 14.725 0 26.662-11.937 26.662-26.661.001-10.437-5.998-19.472-14.735-23.85z",
    fill: "url(#SVGID_12_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m447.822 266.841c0 14.725-11.937 26.661-26.662 26.661s-26.662-11.937-26.662-26.661c0-14.725 11.937-26.662 26.662-26.662s26.662 11.937 26.662 26.662z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.087 242.991c1.798 3.589 2.812 7.639 2.812 11.926 0 14.725-11.937 26.662-26.662 26.662-4.287 0-8.338-1.014-11.927-2.812 4.377 8.737 13.412 14.735 23.85 14.735 14.725 0 26.662-11.937 26.662-26.661 0-10.437-5.999-19.472-14.735-23.85z",
    fill: "url(#SVGID_14_)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrama);
export default __webpack_public_path__ + "static/media/icon-drama.d96f07298c1098c5d383e1962840f835.svg";
export { ForwardRef as ReactComponent };